<template>
  <div class="snooze-control">
    <input class="input" type="number" min="1" max="60" step="1" v-model.number="minutes">
    <span class="snooze-unit">min</span>
    <button class="button" :disabled="!isValid" @click="$emit('snooze', minutes)">Snooze</button>
  </div>
</template>

<script>
export default {
  name: "VirtualRequestSnoozeControl",
  props: {
    defaultMinutes: { type: Number, default: 60 }
  },
  emits: ['snooze'],
  computed: {
    isValid() {
      return Number.isInteger(this.minutes) && this.minutes >= 1 && this.minutes <= 60
    }
  },
  data() {
    return {
      minutes: this.defaultMinutes
    }
  }
}
</script>
